import {Component, Output, EventEmitter} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {CustomValidators} from '../../shared/forms/custom-validators';
import {AuthService} from '../../core/auth/auth.service';
import {CustomerService} from '../../core/customer/customer.service';
import {environment} from '../../../environments/environment';


@Component({
  selector: 'signin',
  styleUrls: ['signin.component.scss'],
  templateUrl: 'signin.component.html'
})
export class SigninComponent {
  @Output() signin = new EventEmitter();

  loginForm: FormGroup;
  errorMessage: string;
  isLoading: boolean = false;
  showResetPassword: boolean = false;

  constructor(private _auth: AuthService,
              private _customerService: CustomerService,
              private _formBuilder: FormBuilder) {

    this.loginForm = this._formBuilder.group({
      username: ['', Validators.compose([Validators.required, CustomValidators.email])],
      password: ['', Validators.required]
    });
  }

  onSubmit(): void {
    this.errorMessage = null;

    if (this.loginForm.valid) {
      let user = this.loginForm.value;
      user.username = user.username + '@' + environment.domain;
      this.isLoading = true;

      this._auth.login(user)
        .finally(() => this.isLoading = false)
        .subscribe(() => {
            this.loginForm.reset();
            this.signin.emit();

            /*this._customerService.getCustomerByUsername()
              .mergeMap(() => this._cards.getCards())
              .subscribe(() => { });*/


            //this._customerService.getCustomerByUsername().subscribe(() => { });
            //this._cards.getCards().subscribe(() => { });
          },
          err => this.errorMessage = err);


      /*        this._auth.login(this.loginForm.value)
                .mergeMap(x => {
                  this.loginForm.reset();
                  this.signin.emit();
                  return this._customerService.getCustomerByUsername(); 
                }).map(() => {
                  this._cards.getCards().subscribe();
                });*/

      /* this._auth.login(this.loginForm.value)
       .map(result => {
         this.loginForm.reset();
         this.signin.emit();
         this._customerService.getCustomerByUsername()
         .finally(() => this.isLoading = false)
         .subscribe();
       },
       err => this.errorMessage = err);*/
      /*.finally(() => this.isLoading = false)
      .subscribe(() => {
        this.loginForm.reset();
        this.signin.emit();
      },
      err => this.errorMessage = err);*/
    }
  }


  showReset(): void {
    this.showResetPassword = !this.showResetPassword;
  }

  onRequestPasswordEvent(event) {
    this.signin.emit(event);
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/account/signin/signin.component.ts